const { marked } = require("marked");

module.exports = ({ value }) => {
  const { attribution, pullQuote } = value;
  const formattedQuote = marked.parseInline(pullQuote);
  const attributionHtml = attribution ? `<p class="
    typography
    $typography/scale:down
  ">
    <span class="layout/block ">${attribution}</span>
  </p>` : '';
  return `
    <div>
      <div class="
        $typography/baseline:solid
        $typography/weight:bold
        layout/flex:column
        layout/width:100%
        $typography/size:extra-large
      ">
        <p class="
          typography
        "><span class="layout/block balance-text" style="">${formattedQuote}</span></p>
        ${attributionHtml}
      </div>
    </div>
  `;
};

